import { Typography } from 'kl-b2c-ui-kit';
import styled from 'styled-components';
import { colorWhite } from 'theme/theme-helper-selectors';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    background-color: ${colorWhite};
    padding: 20px;
    border-radius: 16px;
`;

export const ModuleTitleContainer = styled.div`
    display: flex;
    flex-direction: row;
    padding-bottom: 20px;
`;

export const ModuleTitle = styled.p`
    font-weight: 400;
    font-style: Medium;
    font-size: 12px;

    padding: 4px 8px;
    border-radius: 30px;
    border: 1px solid #1d1d1b59;
`;

export const Title = styled(Typography)`
    padding-bottom: 20px;
    font-weight: 400;
`;

export const Description = styled(Typography)`
    padding-bottom: 20px;
    flex: 1;
    color: rgba(42, 53, 65, 0.7);
`;

export const ButtonContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-top: 60px;
    justify-content: space-between;
`;
export const Lessons = styled(Typography)``;
